import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers } from '@angular/http';
import { environment } from '../../environments/environment';


@Injectable()
export class FeedService {

  constructor(private http: Http) { }

  private apiUrl: String = environment.apiUrl;
  private headers = new Headers({ 'Content-Type': 'application/json' });

  getFeed(start?, articleCountToLoad?): Observable<any> {

    start = start ? start : 0;
    articleCountToLoad = articleCountToLoad ? articleCountToLoad : 3;

    return this.http
        .get(`${this.apiUrl}/feed?start=` + start + '&take=' + articleCountToLoad , { headers: this.headers })
        .map(response => response.json());
  }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app-services/feed.service.ts